import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetLoggedInUser_user_cleaningCompany as CleaningCompanyGenerated,
  GetLoggedInUser as GetLoggedInUserGenerated,
  GetLoggedInUser_user_tomTeamMember as TomTeamMemberGenerated,
  GetLoggedInUser_user as UserDataGenerated,
} from "core/queries/__generated__/GetLoggedInUser";

export interface UserData extends UserDataGenerated {}
export interface CleaningCompany extends CleaningCompanyGenerated {}
export interface GetLoggedInUserResponse extends GetLoggedInUserGenerated {}
export interface TomTeamMember extends TomTeamMemberGenerated {}

export const loggedInUserFragment = gql`
  fragment LoggedInUserFragment on User {
    id
    name
    firstName
    lastName
    email
    avatar {
      id
      url
    }
    cleaningCompany {
      id
    }
    tags {
      id
      name
      tagType
    }
    dispatchRoles {
      name
    }
    tomTeamMember {
      id
      city {
        id
        timezone
      }
    }
    roles
    featureFlags
  }
`;

export const getLoggedInUser = gql`
  query GetLoggedInUser {
    user {
      id
      ...LoggedInUserFragment
    }
  }
  ${loggedInUserFragment}
`;

interface UseGetLoggedInUserQueryOptions {
  skip?: boolean;
}
export const useGetLoggedInUserQuery = ({
  skip = false,
}: UseGetLoggedInUserQueryOptions = {}) =>
  useQuery<GetLoggedInUserResponse>(getLoggedInUser, {
    fetchPolicy: "cache-and-network",
    skip,
    notifyOnNetworkStatusChange: true,
  });
